module.exports = __webpack_public_path__ + "static/media/clouds-left.5c62ba5d.svg";